export const GET_ALL_GAMES = "GET_ALL_GAMES";
export const DELETE_GAME = "DELETE_GAME";
export const GET_ALL_TEAMS_FOR_LEAGUE = "GET_ALL_TEAMS_FOR_LEAGUE";
export const GET_GAME = "GET_GAME";
export const EDIT_GAME = "EDIT_GAME";
export const ADD_GAME = "ADD_GAME";
export const CLEAR_GAMES = "CLEAR_GAMES";
export const CLEAR_ALL_GAMES = "CLEAR_ALL_GAMES";